import React, { useCallback, useEffect, useState } from "react";

const API_BASE = (process.env.REACT_APP_API_BASE || "http://localhost:5000").replace(
  /\/+$/,
  ""
);

const defaultStats = {
  totalRequests: 0,
  sslCount: 0,
  domainProtectionCount: 0,
  accountSecurityCount: 0,
  generalCount: 0,
};

function SecurityHero() {
  const [stats, setStats] = useState(defaultStats);
  const [loading, setLoading] = useState(false);

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);

      const response = await fetch(`${API_BASE}/api/security/stats`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data?.success) {
        throw new Error(data?.message || "Failed to fetch security stats.");
      }

      setStats({
        totalRequests: Number(data?.data?.totalRequests || 0),
        sslCount: Number(data?.data?.sslCount || 0),
        domainProtectionCount: Number(data?.data?.domainProtectionCount || 0),
        accountSecurityCount: Number(data?.data?.accountSecurityCount || 0),
        generalCount: Number(data?.data?.generalCount || 0),
      });
    } catch (error) {
      console.error("Failed to fetch security stats:", error);
      setStats(defaultStats);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();

    window.addEventListener("security-request-created", fetchStats);

    return () => {
      window.removeEventListener("security-request-created", fetchStats);
    };
  }, [fetchStats]);

  const handleScroll = (event, selector) => {
    event.preventDefault();

    const target = document.querySelector(selector);

    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <section className="security-page-section security-hero-new">
      <div className="security-page-container security-hero-container">
        <div className="security-hero-left">
          <span className="security-page-badge">Security Protection</span>

          <h1>Secure Your Account and Domains</h1>

          <p>
            Protect your domains, user data, and digital assets with trusted SSL,
            domain lock, and account protection services.
          </p>

          <div className="security-page-actions">
            <a
              href="#security-main-form"
              className="security-primary-btn security-btn-link"
              onClick={(event) => handleScroll(event, "#security-main-form")}
            >
              Get Protection
            </a>

            <a
              href="#security-how-it-works"
              className="security-secondary-btn security-btn-link"
              onClick={(event) => handleScroll(event, "#security-how-it-works")}
            >
              View Security Tools
            </a>
          </div>

          <div className="security-trust-row">
            <span>🛡 SSL Security</span>
            <span>🔒 Domain Lock</span>
            <span>⚡ Fast Support</span>
          </div>
        </div>

        <div className="security-hero-right">
          <div className="security-shield-card">
            <div className="security-shield-icon">🛡️</div>
            <h3>Protection Dashboard</h3>
            <p>Real-time overview of all security requests and protection tools.</p>

            <div className="security-stats-row">
              <div className="security-stat-card">
                <h3>{loading ? "..." : stats.totalRequests}</h3>
                <p>Total Requests</p>
              </div>

              <div className="security-stat-card">
                <h3>{loading ? "..." : stats.sslCount}</h3>
                <p>SSL</p>
              </div>

              <div className="security-stat-card">
                <h3>{loading ? "..." : stats.domainProtectionCount}</h3>
                <p>Domain Lock</p>
              </div>

              <div className="security-stat-card">
                <h3>{loading ? "..." : stats.accountSecurityCount}</h3>
                <p>Account</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SecurityHero;